export const getRandomKey = () => {
  return (new Date().getTime() + Math.random()).toString()
}
